import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Link } from 'react-router-dom';
import Select from "react-select";
import * as Yup from "yup";
import { useFormik } from "formik";
import withRouter from "components/Common/withRouter";
import { postService, postServiceFail, getBluejayMasterCommunicationChannels } from "../../store/actions";
import { getOnCallPolicies as onGetAllOnCallPolicies } from "../../store/onCallPolicy/actions";
import {getBluejayTeam as onGetBluejayTeam} from "../../store/organization/actions";
import { CardBody, Col, Container, Form, FormFeedback, Input, Label, Row, FormGroup } from "reactstrap";
import Card from "components/PurpleTheme/Card";
import { showNotification } from '../../components/Common/notification'
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { put } from "redux-saga/effects";
import { notification_channel_names as NOTIFICATION_CHANNEL } from "constants/data_types";

const AddService = props => {
  document.title = "Add Service | Temperstack";
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [selectedBluejayTeam, setSelectedBluejayTeam] = useState(null);
  const policies = useSelector((state) => state.onCallPolicy.policies || []);
  const availablePolicies = policies?.map((policies) => ({
    id: policies?.id,
    name: policies?.name,
  }));
  const availablePoliciesOptions = availablePolicies?.length > 0
    ? availablePolicies.map((policy) => ({
      label: policy.name,
      value: policy.id,
    }))
    : [];
  const [selectedIds, setSelectedIds] = useState([]);
  useEffect(() => {
    dispatch(onGetAllOnCallPolicies());
  }, [onGetAllOnCallPolicies]);

  const { services } = useSelector(state => ({
    services: state.Service.services
  }));

  const bluejayTeams = useSelector((state) => state.Organization.bluejay_teams || []);
  const availableTeamsOptions = bluejayTeams?.map((teams) => ({
    label: teams.name,
    value: teams.id,
  }));
  useEffect(() => {
    dispatch(onGetBluejayTeam());
  }, [dispatch]);
  useEffect(() => {
    if (!selectedBluejayTeam && availableTeamsOptions.length > 0) {
      const defaultTeam = availableTeamsOptions.find((option) => option.label === "Default Team");
      if (defaultTeam && !selectedBluejayTeam) {
        setSelectedBluejayTeam(defaultTeam);
      }
    }
  }, [availableTeamsOptions]);

  const handleTeamChange = (selectedOption) => {
    setSelectedBluejayTeam(selectedOption);
    validation.setFieldValue("bluejay_team", selectedOption.value);
  };

  useEffect(() => {
    dispatch(getBluejayMasterCommunicationChannels());
  }, [getBluejayMasterCommunicationChannels]);


  const { communication_channels } = useSelector(state => ({
    communication_channels: state.Service.communication_channels,
  }))
  useEffect(() => {
    communication_channels.map((channel) => {
      if (["Slack", "Email", "Voice"].includes(channel.name)) {
        const ids = selectedIds
        ids.push(channel.id)
        setSelectedIds(ids)
      }

    })
  }, [communication_channels])

  const domain = window.location.hostname;

  const handleCheckboxChange = (id, checked) => {
    const updatedIds = checked
      ? [...selectedIds, id]
      : selectedIds.filter(selectedId => selectedId !== id);

    setSelectedIds(updatedIds);

  };
  const validation = useFormik({
    enableReinitialize: true,
  
    initialValues: {
      email_id: "",
      name: "",
      slack_channel: "",
      on_call_policy: "",
      bluejay_team_id: "",
    },
    validate: (values) => {
      const errors = {};
      const emailArray = values.email_id.split(',').map(email => email.trim());
      if (!values.email_id) {
        errors.email_id = 'Please Enter the Email ID';
      } else {
        for (let i = 0; i < emailArray.length; i++) {
          const email = emailArray[i];
          if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email)) {
            errors.email_id = `Invalid Email ID at position ${i + 1}: ${email}`;
            break;
          }
        }
      }
      return errors;
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please Enter Service Name"),
      email_id: Yup.string().required("Please Enter the Email ID"),
      slack_channel: Yup.string(),
      on_call_policy: Yup.string(),
    }),
    onSubmit: (values, { resetForm }) => {
      values.email_id = values.email_id.split(',').map(email => email.trim()).join(',');
      values.bluejay_team_id = selectedBluejayTeam ? selectedBluejayTeam.value : null;
      const selectedPolicy = availablePolicies.find(
        (policy) => policy.name === values.on_call_policy
      );
      values.on_call_policy = selectedPolicy ? selectedPolicy.id : null;
      const isServiceNameUnique = !services.some(
        (service) => service.name === values.name
      );
      values.selected_notification_channels = selectedIds;
      if (!isServiceNameUnique) {
        showNotification("error", "Application Service name already exists");
        resetForm();
      } else {
        dispatch(postService(values, props.router.navigate));
        navigate('/temperstack-notifications');
      }
    },
  });

  const customStyles = {
    zIndex: 9999,
    control: (provided, state) => ({
      ...provided,
      background: '#382b42', // Background color of the control (react-select)
      borderRadius: 0,
      color: "white",
      zIndex: 100,
      position:"relative",
      borderColor: state.isFocused ? 'rgb(white, 1)' : 'rgb(white, 0.7)', // Border color when focused
    }),
    option: (provided, state) => ({
      ...provided,
      position:"relative",
      zIndex: 100,
      backgroundColor: state.isSelected ? '#292036' : state.isFocused ? '#2d2941' : '#382b42',
      color: state.isSelected ? '#ffffff' : '#ffffff', // Text color of dropdown options
    }),
    menu: (provided) => ({
      ...provided,
      background: '#382b42',
      position: "absolute",
      zIndex: 200, // Background color of the dropdown menu

    }),
    singleValue: (provided) => ({
      ...provided,
      position:"relative",
      color: '#ffffff', // Color of the selected value
      zIndex: 100, 
    }),
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title="Temperstack" breadcrumbItem="Add Service" />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <Form
                    className="form-horizontal"
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                    }}
                  >
                    <Row>
                      <Col sm="12">
                        <div className="mb-3">
                          <Label htmlFor="name">Service Name</Label>
                          <Input
                            id="name"
                            name="name"
                            required
                            type="text"
                            className="input"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.name || ""}
                            invalid={
                              validation.touched.name && validation.errors.name ? true : false
                            }
                          />
                          {validation.touched.name && validation.errors.name ? (
                            <FormFeedback type="invalid">{validation.errors.name}</FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                      <Col sm="12">
                        <div className="mb-3">
                          <Label htmlFor="name">Group Email</Label>
                          <Input
                            id="email_id"
                            name="email_id"
                            type="text"
                            required
                            className="input"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            placeholder="e.g. example@gmail.com OR example@gmail.com,example2@gmail.com"
                            value={validation.values.email_id || ""}
                            invalid={
                              validation.touched.email_id && validation.errors.email_id ? true : false
                            }
                          />    
                          {validation.touched.email_id && validation.errors.email_id && (
                            <FormFeedback type="invalid">{validation.errors.email_id}</FormFeedback>
                          )}
                        </div>
                      </Col>
                      <Col sm="12">
                        <div className="mb-3">
                          <Label htmlFor="name">Slack Channel</Label>
                          <Input
                            id="slack_channel"
                            name="slack_channel"
                            type="text"
                            className="input"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.slack_channel || ""}
                            invalid={
                              validation.touched.slack_channel && validation.errors.slack_channel ? true : false
                            }
                          />
                          {validation.touched.slack_channel && validation.errors.slack_channel && (
                            <FormFeedback type="invalid">{validation.errors.slack_channel}</FormFeedback>
                          )}
                        </div>
                      </Col>
                      <Col sm="12">
                          <div className="mb-3">
                          <Label htmlFor="bluejay_team">Select Team</Label>
                          <Select
                            id="bluejay_team"
                            name="bluejay_team"
                            onBlur={validation.handleBlur}
                            value={selectedBluejayTeam}
                            placeholder="Select a team"
                            onChange={handleTeamChange}
                            options={availableTeamsOptions}
                            className="select2-selection col-form-label bg-transparent text-white"
                            theme={(theme) => ({
                              ...theme,
                              borderRadius: 0,
                              colors: {
                                ...theme.colors,
                                neutral0: '#222736',
                                neutral5: '#485EC4',
                                neutral10: '#485EC4',
                                neutral60: '#ffffff',
                                neutral70: '#ffffff',
                                neutral80: '#ffffff',
                                neutral90: '#ffffff',
                                primary: '#485EC4',
                              },
                            })}
                            styles={customStyles}
                          />
                        </div>
                      </Col>
                      <Col sm="12">
                        <div className="mb-3">
                          <Label htmlFor="name">Select On-Call policy</Label>
                          <Select
                            id="on_call_policy"
                            name="on_call_policy"
                            onBlur={validation.handleBlur}
                            value={availablePoliciesOptions.find(
                              (option) => option.label === validation.values.on_call_policy
                            ) || availablePoliciesOptions[0]}
                            placeholder="Add on-call policy"
                            onChange={(selectedOption) => {
                              validation.setFieldValue("on_call_policy", selectedOption.label);
                            }}
                            options={availablePoliciesOptions}
                            className="select2-selection col-form-label bg-transparent text-white"
                            theme={(theme) => ({
                              ...theme,
                              borderRadius: 0,
                              colors: {
                                ...theme.colors,
                                neutral0: '#222736',
                                neutral5: '#485EC4',
                                neutral10: '#485EC4',
                                neutral60: '#ffffff',
                                neutral70: '#ffffff',
                                neutral80: '#ffffff',
                                neutral90: '#ffffff',
                                primary: '#485EC4',
                              },
                            })}
                            styles={customStyles}
                          />
                        </div>
                        <div className="mb-3 d-flex align-items-center">
                          <Form>
                            <Label htmlFor="name" className="me-3">Receive Alert Notification At:</Label>
                            <ul style={{ justifyContent: 'center', alignItems: 'center' }}>
                              {communication_channels.map((channel) => {
                                if ((domain !== 'msteamtestaccount.temperstack.com' || domain !== '10xengg.myapp.com' || !domain.endsWith('temperstack.dev')) && channel.name === NOTIFICATION_CHANNEL.MS_TEAMS) {
                                  return null;
                                }
                                return (
                                  <FormGroup check inline key={channel.id} className="me-3">
                                    <Input
                                      type="checkbox"
                                      id={channel.id}
                                      name={channel.name}
                                      checked={selectedIds.includes(channel.id)}
                                      onChange={(event) => handleCheckboxChange(channel.id, event.target.checked)}
                                      style={{ display: 'none' }}
                                    />
                                    <Label check for={channel.id} style={{ display: 'flex', alignItems: 'center' }}>
                                      <i
                                        className={
                                          selectedIds.includes(channel.id)
                                            ? 'bx bx-check-square bx-sm'
                                            : 'bx bx-square bx-sm'
                                        }
                                        onClick={() => handleCheckboxChange(channel.id, !selectedIds.includes(channel.id))}
                                        style={{ marginRight: '0.5rem' }}
                                      ></i>
                                      {channel.name}
                                    </Label>
                                  </FormGroup>)
                              })}
                            </ul>
                          </Form>
                        </div>
                      </Col>
                    </Row>
                    <div className="d-flex flex-wrap gap-2">
                      <button type="submit" className="btn btn-primary">
                        Save Changes
                      </button>
                      <Link to="/temperstack-notifications">
                        <button className="btn btn-danger">
                          Cancel
                        </button>
                      </Link>
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(AddService);

AddService.propTypes = {
  history: PropTypes.object,
};

